import { LongFormPollResponseForm } from "./long_form_poll_response_form";
import { NonLongFormPollResponseForm } from "./non_long_form_poll_response_form";

import { PollSessionType, PollType, PollTypeType } from "shared/types";

type PollResponseFormProps = {
  poll: PollType;
  pollSession: PollSessionType;
  userId: string;
};

function PollResponseForm({ poll, pollSession, userId }: PollResponseFormProps) {
  return poll.type === PollTypeType.LongForm ? (
    <LongFormPollResponseForm poll={poll} pollSession={pollSession} userId={userId} />
  ) : (
    <NonLongFormPollResponseForm poll={poll} pollSession={pollSession} userId={userId} />
  );
}

export { PollResponseForm };
